import { FC } from 'react';
import { Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * バリデーションメッセージ
 */
interface Props {
  /** バリデーションメッセージのリスト */
  validationMessages: string[];
}

/**
 * ValidationMessagesはバリデーションメッセージを表示するコンポーネントです。
 *
 * @param {Props} props - バリデーションメッセージのプロパティ
 * @returns {JSX.Element} - バリデーションメッセージのリスト要素
 */
export const ValidationMessages: FC<Props> = ({ validationMessages }) => {
  return (
    <ul className={styles.careerRecommendJobList__validationMessageList}>
      {validationMessages.map((message) => (
        <Text as="li" size="10" key={message}>
          ・{message}
        </Text>
      ))}
    </ul>
  );
};
